import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _capitalize from "lodash/capitalize";
var _excluded = ["text", "url", "type"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useContext } from 'react';
import classnames from 'classnames';
import Utility from "../../Utility/Utility";
import { Button } from "../../Button/Button/Button";
import { MemberCarousel } from "../../MemberCarousel/MemberCarousel";
import { TwoColumn } from "../../TwoColumn/TwoColumn";
import { ToggleButton } from "../../Button/ToggleButton/ToggleButton";
import { Container } from "../../Container/Container/Container";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { Image } from "../../Image/Image/Image";
import { ThemeContext } from "../../../context/theme.context";
import styles from "./FAQSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var faqAnswerTypes = ['memberAnswers', 'twoColumnAnswer', 'fullWidthAnswer'];
export var faqAlign = ['left', 'center'];
export var faqEyebrowTypogs = ['eyebrow1', 'eyebrow2', 'eyebrow3'];
export var FaqSlice = function FaqSlice(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    _ref$eyebrow = _ref.eyebrow,
    eyebrow = _ref$eyebrow === void 0 ? {
      text: '',
      typog: 'eyebrow1'
    } : _ref$eyebrow,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? {
      ariaLevel: 2,
      text: '',
      typog: 'headline3',
      variant: 'default'
    } : _ref$heading,
    faqData = _ref.faqData,
    _ref$questionTypog = _ref.questionTypog,
    questionTypog = _ref$questionTypog === void 0 ? 'bodycopyExtraLarge' : _ref$questionTypog;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var theme = useContext(ThemeContext);
  var renderQuestions = function renderQuestions() {
    return faqData === null || faqData === void 0 ? void 0 : faqData.map(function (data, key) {
      var questionWithoutTags = typeof data.question === 'string' ? Utility.stripTags(data.question) : '';
      return /*#__PURE__*/_jsxs("div", {
        className: styles.qaContainer,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.questionContainer,
          children: /*#__PURE__*/_jsx(ToggleButton, _objectSpread(_objectSpread({
            accessibilityLabel: show === key ? "collapse ".concat(questionWithoutTags, " button") : "expand ".concat(questionWithoutTags, " button"),
            "aria-expanded": show === key,
            iconPosition: "right",
            iconSize: "16px",
            onPress: function onPress() {
              return setShow(show === key ? null : key);
            },
            styleType: show === key ? 'quaternary' : 'tertiary',
            className: classnames(styles.questionToggleButtonButton, {
              [styles.questionToggleButtonButtonDarkBg]: theme === 'darkBackground'
            }),
            flexEnd: true
          }, data.buttonAttributes), {}, {
            children: /*#__PURE__*/_jsx(Text, {
              className: styles.question,
              typog: questionTypog,
              children: data.question
            })
          }))
        }), /*#__PURE__*/_jsx("div", {
          className: show === key ? styles.showAnswers : styles.hideAnswers,
          children: (data === null || data === void 0 ? void 0 : data.answerType) && data.answers && renderAnswers(data.answerType, data.answers)
        }), /*#__PURE__*/_jsx("hr", {
          className: styles.lineBreak
        })]
      }, key);
    });
  };
  var renderButton = function renderButton(button) {
    var _ref2 = button || {},
      text = _ref2.text,
      url = _ref2.url,
      type = _ref2.type,
      otherProps = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      className: styles.twoColumnButton,
      url: url,
      type: type
    }, otherProps), {}, {
      children: text
    }));
  };
  var renderTwoColumn = function renderTwoColumn(answer) {
    var _ref3 = answer || {},
      heading = _ref3.heading,
      body = _ref3.body,
      button = _ref3.button,
      image = _ref3.image,
      columnsReverse = _ref3.columnsReverse;
    var hasImage = image === null || image === void 0 ? void 0 : image.src;
    return /*#__PURE__*/_jsxs(TwoColumn, {
      columnsReverse: hasImage ? columnsReverse : false,
      offset: !hasImage ? 'left' : 'none',
      breakpoint: "small",
      padding: false,
      columnOneConfig: {
        verticalAlign: 'center'
      },
      columnTwoConfig: {
        verticalAlign: 'center'
      },
      background: {
        height: 0,
        theme: theme
      },
      children: [/*#__PURE__*/_jsxs("div", {
        children: [(heading === null || heading === void 0 ? void 0 : heading.text) && /*#__PURE__*/_jsx(HeadingText, {
          richText: true,
          className: styles.twoColumnHeading,
          align: "left",
          typog: heading !== null && heading !== void 0 && heading.typog ? heading.typog : 'subhead2',
          ariaLevel: heading.ariaLevel,
          variant: heading.variant,
          children: heading.text
        }), (body === null || body === void 0 ? void 0 : body.text) && /*#__PURE__*/_jsx(Text, {
          richText: true,
          className: styles.twoColumnBody,
          typog: "bodycopyLarge",
          "data-e2e-name": "tout_body_text",
          children: body.text
        }), (button === null || button === void 0 ? void 0 : button.text) && button.url && renderButton(button)]
      }), /*#__PURE__*/_jsx("div", {
        className: classnames({
          [styles.twoColumnImageWrapper]: hasImage
        }),
        children: (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
          className: styles.twoColumnImage
        }))
      })]
    });
  };
  var renderAnswers = function renderAnswers(answerType, answers) {
    switch (answerType) {
      case 'memberAnswers':
        return /*#__PURE__*/_jsx(MemberCarousel, {
          members: answers !== null && answers !== void 0 && answers.memberAnswers ? answers.memberAnswers : []
        });
      case 'twoColumnAnswer':
        return renderTwoColumn(answers === null || answers === void 0 ? void 0 : answers.twoColumnAnswer);
      case 'fullWidthAnswer':
        return /*#__PURE__*/_jsx(Text, {
          richText: true,
          typog: 'bodycopyLarge',
          className: styles.fullWidthAnswer,
          children: answers === null || answers === void 0 ? void 0 : answers.fullWidthAnswer
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.wrapper,
      children: [align && ((eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.text) || (heading === null || heading === void 0 ? void 0 : heading.text)) && /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.header, styles["headerAlign".concat(_capitalize(align))]),
        children: [(eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.text) && eyebrow.typog && /*#__PURE__*/_jsx(Text, {
          className: styles.eyebrow,
          typog: eyebrow.typog,
          children: eyebrow.text
        }), (heading === null || heading === void 0 ? void 0 : heading.text) && heading.ariaLevel && heading.typog && heading.variant && /*#__PURE__*/_jsx(HeadingText, {
          align: align,
          ariaLevel: heading.ariaLevel,
          typog: heading.typog,
          variant: heading.variant,
          children: heading.text
        }, "heading")]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.questionsContainer,
        children: faqData && renderQuestions()
      })]
    })
  });
};